import clsx from 'clsx';

type Props = {
  /** 追加のクラス（高さ調整など） */
  className?: string;
};

/**
 * グレー（#f6f6f6）の枠に中央寄せで「表示するデータがありません」を表示する。
 */
export default function DashboardEmptyState({ className }: Props) {
  return (
    <div
      className={clsx(
        'flex flex-1 items-center justify-center rounded-sm bg-gray px-lg py-xs',
        className
      )}
    >
      <p className="text-base leading-[1.7] text-sub">表示するデータがありません</p>
    </div>
  );
}
